import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    chip: {
        backgroundColor: theme.palette.primary.main,
        padding: '2px 10px',
        margin: '5px',
        marginTop: '5px',
        borderRadius: '4px',
        color: 'white',
        fontSize: 12,
    },
    chipWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        maxHeight: 200,
        overflow: 'auto',
        scwrollbarWidth: 'thin',

        '&::-webkit-scrollbar': {
            width: 4.5,
            height: 4.5,
        },

        '&::-webkit-scrollbar-thumb': {
            background: '#d0d0d0',
            borderRadius: 7,
        },

        [theme.breakpoints.down('md')]: {
            minWidth: '200px',
        },
    },
}));
